import rfdc from 'rfdc'

export default function useDeepClone<T>(value: T) {
  return rfdc({ proto: true })(value)
}
